import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./home/Home.vue";
import About from "./about/About.vue";
import Imprint from "./imprint/Imprint.vue";
import Privacy from "./privacy/Privacy.vue";
import Conditions from "./conditions/Conditions.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: Home },
    { path: "/about", component: About },
    { path: "/impressum", component: Imprint },
    { path: "/datenschutz", component: Privacy },
    { path: "/reisebedingungen", component: Conditions },
    { path: "*", redirect: "/" }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  next();
  //setTimeout(() => next(), 1000);
});

export default router;
